import React, { useState } from "react";
import { Row } from "reactstrap";
import {seprateAssetDetails} from '../assets/constants/seprate-asset-details';
import NaviFaqItems from "./NaviFaqItems";

export default function SeprateFaq(props) {
  const [answers, setAnswers] = useState(new Array(10).fill(true));
  const [id, setId] = useState("");
  
  const toggle = (ans) => {
    let answer = answers;
    answer[ans] = !answer[ans];
    setAnswers([...answer]);
  };

  const changeId = (val) => {
    let presentUrl = window.location.hash.split('/')[1];
    window.location.hash = presentUrl + "/" + val;
    setId(val)
  }

  return (
    <Row className="navi-faq">
      <p className="sub-title mb-4 font-weight-semi-bold mt-5">
        Frequently asked questions
      </p>
      <div className="container mb-5">
      <NaviFaqItems
        bordered={true}
        toggle={toggle}
        answer={answers}
        faqs={seprateAssetDetails.faq}
        id={id}
        isOrobonds={props.isOrobonds}
        redirect={props.toggle}
      />
      </div>
    </Row>
  );
}
